import React from 'react'
//Bibliotecas
import styled from 'styled-components';
//Componentes
import CursoCard from './CursoCard';
//Imágenes
import vacio from '../../../assets/images/vacio.png';

function CursoCards({ cursos, refresh }) {

    const CursoCards = (
        <Cards>
            {cursos.map((curso) =>
                <CursoCard curso={curso} refresh={refresh}></CursoCard>
            )}
        </Cards>
    );

    return (
        <Wrapper>
            {cursos.length > 0 ?<><Title>Tus cursos</Title>{CursoCards}</> : <><Title>No tienes ningún curso creado</Title><img src={vacio}/></>}
        </Wrapper>
    )
}

export default CursoCards

const Wrapper = styled.div`
    width:100%;
    margin-top:32px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    img{
        width:20%;
    }
`;

const Cards = styled.div`
    width:80%;
    display:grid;
    justify-content:center;
    grid-template-columns:repeat(auto-fill, 29%);
    grid-gap:32px 64px;
    margin:40px;
`;


const Title = styled.h1`
    color: var(--color-blanco);
`;

